var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMore = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    isolation: "isolate"
  },
  viewBox: "0 0 16 4",
  width: 16,
  height: 4,
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: " M 2 0 C 0.9 0 0 0.9 0 2 C 0 3.1 0.9 4 2 4 C 3.1 4 4 3.1 4 2 C 4 0.9 3.1 0 2 0 Z  M 14 0 C 12.9 0 12 0.9 12 2 C 12 3.1 12.9 4 14 4 C 15.1 4 16 3.1 16 2 C 16 0.9 15.1 0 14 0 Z  M 8 0 C 6.9 0 6 0.9 6 2 C 6 3.1 6.9 4 8 4 C 9.1 4 10 3.1 10 2 C 10 0.9 9.1 0 8 0 Z ",
  fill: "rgb(0,0,0)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/more.d9dd8868b3ea4a10187e5b1cbdd9f61b.svg";